import { Rating } from '@/features/types';
import classes from './RiskRating.module.css';

interface Props {
  rating: Rating;
  label?: string;
  variant?: 'primary' | 'secondary';
  'data-testid'?: string;
}

const ratingClasses: Record<Rating, { indicator: string; label: string }> = {
  [Rating.Unknown]: {
    indicator: classes.indicatorUnknown,
    label: classes.labelUnknown,
  },
  [Rating.None]: {
    indicator: classes.indicatorNone,
    label: classes.labelNone,
  },
  [Rating.Minor]: {
    indicator: classes.indicatorMinor,
    label: classes.labelMinor,
  },
  [Rating.Low]: {
    indicator: classes.indicatorLow,
    label: classes.labelLow,
  },
  [Rating.Medium]: {
    indicator: classes.indicatorMedium,
    label: classes.labelMedium,
  },
  [Rating.High]: {
    indicator: classes.indicatorHigh,
    label: classes.labelHigh,
  },
};

export const RiskRating = ({
  rating,
  label,
  variant = 'primary',
  'data-testid': testId,
}: Props) => {
  const variantClass =
    variant === 'primary' ? classes.labelPrimary : classes.labelSecondary;
  const ratingClass = ratingClasses[rating] ?? ratingClasses[Rating.Unknown];
  return (
    <div
      className={`${classes.label} ${variantClass} ${ratingClass.label}`}
      data-rating={Rating[rating]}
      data-variant={variant}
      data-testid={testId}
    >
      <span className={`${classes.indicator} ${ratingClass.indicator}`} />
      <span className={classes.text}>{label}</span>
    </div>
  );
};
